export default "__VITE_ASSET__DcN29FS7__"